import { atom } from "jotai";

/**
 * The URL on which the websocket should connect.
 */
export const socketUrlAtom = atom<string | null>(null);
